import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PersonPointService } from 'app/services/models/person-point.service';
import { Turkish } from 'flatpickr/dist/l10n/tr';
import moment from 'moment';
import { FlatpickrOptions } from 'ng2-flatpickr';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-person-point-dialog',
  templateUrl: './person-point-dialog.component.html',
  styleUrls: ['./person-point-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PersonPointDialogComponent implements OnInit {
  @Input() data: { personId: number; row: any };

  personPointForm: FormGroup;

  date = new Date();
  date2 = moment().add(8, 'hours').toDate();

  public dateTimeStartOptions: FlatpickrOptions = {
    altInput: true,
    enableTime: true,
    dateFormat: 'd.m.Y H:i',
    altFormat: 'd.m.Y H:i',
    locale: Turkish,
    defaultDate: this.date
  };

  public dateTimeEndOptions: FlatpickrOptions = {
    altInput: true,
    enableTime: true,
    dateFormat: 'd.m.Y H:i',
    altFormat: 'd.m.Y H:i',
    locale: Turkish,
    defaultDate: this.date2
  };

  statusList: any[] = [
    { id: 1, name: "Normal Mesai." },
    { id: 2, name: "Eksik Mesai" },
    { id: 3, name: "Fazla Mesai" },
    { id: 4, name: "Resmi Tatil" }
  ]

  constructor(
    public activeModal: NgbActiveModal,
    private personPointService: PersonPointService,
    private fb: FormBuilder,
    private toastrService: ToastrService) {


  }

  ngOnInit(): void {
    console.log(this.data.row);
    this.personPointForm = this.fb.group({
      workRate: [null],
      overtimeHours: [null],
      workDate: [null, [Validators.required]],
      endDate: [null, [Validators.required]],
      personId: this.data.personId,
      status: [1, [Validators.required]]
    });

    if (this.data.row) {
      this.date = new Date(this.data.row.workStart);
      this.date2 = new Date(this.data.row.workEnd)
      this.personPointForm.patchValue({
        workRate: this.data.row.workRate,
        overtimeHours: this.data.row.overtimeHours,
        workStart: this.date,
        workEnd: this.date2,
        personId: this.data.row.personId,
        status: this.data.row.status
      });
    }
  }

  isFormValid(): boolean {
    const status = this.personPointForm.get('status')?.value;
    const workRate = this.personPointForm.get('workRate')?.value;
    const overtimeHours = this.personPointForm.get('overtimeHours')?.value;

    // Eğer status 3 veya 4 ise workRate ve overtimeHours kontrol edilir
    if (status === 3 || status === 4) {
      return !!(this.personPointForm.valid && workRate && overtimeHours);
    }

    // Diğer durumlarda sadece formun genel validasyon durumunu kontrol et
    return this.personPointForm.valid;
  }

  closeModal() {
    this.activeModal.close(false);
  }

  async onSumbit() {
    if (this.personPointForm.valid) {
      console.log(this.personPointForm.value);

      // workDate ve endDate alanlarını al ve Date nesnesine çevir
      const workDateArray = this.personPointForm.value.workDate;
      const endDateArray = this.personPointForm.value.endDate;

      const workDate = new Date(workDateArray[0]) // Diziden ilk tarihi al
      const endDate = new Date(endDateArray[0]) // Diziden ilk tarihi al
      workDate.setHours(workDate.getHours() + 3); // 3 saat ekliyoruz

      endDate.setHours(endDate.getHours() + 3);

      if (this.data.row != null) {
        const response = await this.personPointService.updatePersonPoint({
          id: this.data.row.id,
          personId: this.data.personId,
          overtimeHours: this.personPointForm.value.overtimeHours,
          status: this.personPointForm.value.status,
          workStart: workDate, // Date formatında gönderiliyor
          workEnd: endDate,    // Date formatında gönderiliyor
          workRate: this.personPointForm.value.workRate
        });
        if (response.status == true) {
          this.closeModal();
          this.toastrService.success(response.message);
          this.personPointService.sendEvent(true);
        } else {
          this.toastrService.error(response.message);
        }
      } else {
        const response = await this.personPointService.cretaPersonPoint({
          personId: this.data.personId,
          overtimeHours: this.personPointForm.value.overtimeHours,
          status: this.personPointForm.value.status,
          workStart: workDate, // Date formatında gönderiliyor
          workEnd: endDate,    // Date formatında gönderiliyor
          workRate: this.personPointForm.value.workRate
        });
        if (response.status == true) {
          this.closeModal();
          this.toastrService.success(response.message);
          this.personPointService.sendEvent(true);
        } else {
          this.toastrService.error(response.message);
        }
      }
    }
  }

}
